.as{justify-content:center;}